import { computeParamsForPage } from '~/utils/searchParameters';
import NRouter from '~/router';

export default function getPageParams(
  pageNumber,
  searchParameters,
  verticalName,
  queryOrigin,
  alertLanding,
  tg
) {
  const params = computeParamsForPage(
    pageNumber,
    searchParameters,
    verticalName,
    queryOrigin,
    alertLanding,
    tg
  );

  if (!pageNumber) {
    return undefined;
  }

  const { as, href } = NRouter.findAndGetUrls(params.routeName, params).urls;

  return {
    number: pageNumber,
    urls: {
      as,
      href,
    },
  };
}



// WEBPACK FOOTER //
// ./app/Serp/components/shared/Pager/utils/getPageParams.js